import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Car } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
      <div className="text-center">
        {/* Animated Car */}
        <div className="relative mb-8">
          <div className="text-[150px] sm:text-[200px] font-bold text-gray-800 select-none">
            404
          </div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-bounce">
            <Car size={80} className="text-white" />
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl sm:text-4xl font-bold text-white mb-4">
          Oops ! Mauvaise direction
        </h1>
        <p className="text-gray-400 text-lg mb-8 max-w-md mx-auto">
          Cette page n'existe pas. Pas de panique, notre chauffeur va vous ramener sur la bonne route.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-white text-gray-900 hover:bg-gray-100 px-8 py-6 text-lg">
              <Home size={20} className="mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="border-gray-600 text-white hover:bg-gray-800 px-8 py-6 text-lg"
          >
            <ArrowLeft size={20} className="mr-2" />
            Page précédente
          </Button>
        </div>

        {/* Decoration */}
        <div className="mt-16 flex justify-center gap-2">
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '200ms' }}></div>
          <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '400ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
